import React from 'react';

export const MatchEventsModuleStageHeader = ({stage}) => {
  const {scoreText, name, isCurrent} = stage;

  return (
    !isCurrent ? <div className={'match-event-module-stages-header-container'}>
      <div className={'match-event-module-stages-header-name-container'}>{name}</div>
      <div className={'match-event-module-stages-header-score-container'}>{scoreText}</div>
    </div> : null
  )
};